import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../../../Context/AuthContext";
import { DataToExcel } from "../../../../utils/helpers";
import { ErrorMessage } from "../../../../utils/toastify";
import { getCampaignReport } from "../api/campaignReportsApi";

const REPORT_NAMES = {
  replies: "Respuestas",
  actions: "Acciones",
  rejects: "Rechazados",
};

export const useDownloadCampaignReport = ({
  uidCampaign,
  idCampaignMessage,
}) => {
  const auth = useAuth();
  const { token } = auth.getSessionData();

  return useMutation({
    mutationKey: ["downloadCampaignReport", uidCampaign, idCampaignMessage],
    mutationFn: async (typeReport = "replies") => {
      const response = await getCampaignReport({
        token,
        uidCampaign,
        idCampaignMessage,
        typeReport,
      });

      return {
        typeReport,
        data: response.data,
      };
    },
    onSuccess: ({ typeReport, data }) => {
      if (data) {
        DataToExcel(
          data,
          `Reporte_${REPORT_NAMES[typeReport]}_Campaña_${uidCampaign}`,
        );
      }
    },
    onError: (error) => {
      console.log(error);
      ErrorMessage(error.message);
    },
  });
};
